( function ( $ ) {
	const indyTeaserSlider = $( '.wp-block-indy-testimonials' );
	const initClass = 'wp-block-indy-testimonials--init';
	indyTeaserSlider.addClass( initClass );

	document.onreadystatechange = function () {
		if ( document.readyState === 'complete' ) {
			if ( indyTeaserSlider.length ) {
				indyTeaserSlider.each( function ( index, element ) {
					const quotes = $( 'q', element );
					let maxHeight = 0;
					quotes.each( ( i, quote ) => {
						const heigth = $( quote ).height();
						maxHeight = heigth > maxHeight ? heigth : maxHeight;
					} );
					$( '.wp-block-indy-testimonial', element ).height( maxHeight + 60 );
					$( this ).removeClass( initClass );
				} );

				indyTeaserSlider.slick( {
					autoplay: true,
					autoplaySpeed: 5000,
					arrows: false,
					dots: false,
					draggable: true,
					pauseOnFocus: false,
					pauseOnHover: false,
					swipe: false,
					speed: 750,
					vertical: true,
					verticalSwiping: true,
					easing: 'easeout',
				} );
			}
		}
	};
} )( jQuery );
